var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PivotTableModal',{attrs:{"cur-widget":_vm.dataKey,"cur-headers":_vm.headers,"cur-data-providers":_vm.dataProviders}}),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.editTable}},[_vm._v("Edit")]),_vm._v(" "),_c('div',{attrs:{"id":'pivottable_' + _vm.dataKey}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f65bb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PivotTable/index.vue
// module id = null
// module chunks = 